import React from 'react';
import { Section } from './ui/Section';
import { X, Check } from 'lucide-react';
export function FinalComparisonTable() {
  const comparison = [{
    cat: '⏰ Tiempo',
    sin: '3-5 horas/semana planificando desde cero',
    con: '10 min/semana. El resto es entrenar'
  }, {
    cat: '😓 Ejercicios',
    sin: 'Siempre los mismos → los jugadores se aburren',
    con: '60+ sesiones distintas → siempre hay algo nuevo'
  }, {
    cat: '💸 Retención',
    sin: 'Jugadores que abandonan sin saber por qué',
    con: 'Sistema de progresión → retención visible'
  }, {
    cat: '📋 Progresión',
    sin: 'Sin secuencia clara de nivel a nivel',
    con: '6 tomos con progresión anual → mejoran y se quedan'
  }, {
    cat: '😨 Táctica',
    sin: 'Pizarra improvisada = confusión en el partido',
    con: 'Diagramas listos → todos entienden el plan'
  }, {
    cat: '👥 Grupos mixtos',
    sin: 'Niveles mezclados = caos en el entrenamiento',
    con: 'Variaciones en 3 niveles → todos progresan juntos'
  }, {
    cat: '📱 Comunicación',
    sin: 'Sin sistema de seguimiento de jugadores',
    con: 'Planillas listas + fichas individuales por jugador'
  }, {
    cat: '💼 Profesionalismo',
    sin: 'Sin identidad profesional visible',
    con: 'Sistema que justifica cobrar lo que merecés'
  }];
  return <Section className="bg-gray-50" data-id="element-97">
      <div className="text-center max-w-4xl mx-auto mb-6 md:mb-12" data-id="element-98">
        <h2 className="text-2xl md:text-5xl font-black text-dark mb-3 md:mb-6" data-id="element-99">
          ⚽ MEGAPACK FÚTBOL RESUELTO™
        </h2>
        <p className="text-base md:text-xl text-gray-700 font-bold mb-1 md:mb-2" data-id="element-100">
          El próximo entrenamiento podés volver a improvisar.
        </p>
        <p className="text-base md:text-xl text-primary font-bold mb-4 md:mb-8" data-id="element-101">
          O podés llegar a la cancha con todo resuelto desde hoy.
        </p>
        <h3 className="text-xl md:text-2xl font-black text-dark" data-id="element-102">
          ¿Cuánto cuesta NO tenerlo?
        </h3>
      </div>

      <div className="max-w-5xl mx-auto" data-id="element-103">
        {/* Desktop Table */}
        <div className="hidden md:block overflow-hidden rounded-2xl shadow-sm border border-gray-200" data-id="element-104">
          <table className="w-full text-left border-collapse bg-white" data-id="element-105">
            <thead data-id="element-106">
              <tr data-id="element-107">
                <th className="p-4 bg-gray-100 font-bold text-dark w-1/4 text-base" data-id="element-108"></th>
                <th className="p-4 bg-red-50 font-bold text-red-700 w-3/8 text-center border-r border-gray-200 text-base" data-id="element-109">
                  <div className="flex items-center justify-center" data-id="element-110">
                    <X className="w-5 h-5 mr-1.5" data-id="element-111" /> SIN MEGAPACK
                  </div>
                </th>
                <th className="p-4 bg-green-50 font-bold text-primary w-3/8 text-center text-base" data-id="element-112">
                  <div className="flex items-center justify-center" data-id="element-113">
                    <Check className="w-5 h-5 mr-1.5" data-id="element-114" /> CON MEGAPACK
                  </div>
                </th>
              </tr>
            </thead>
            <tbody data-id="element-115">
              {comparison.map((row, i) => <tr key={i} className="border-b border-gray-100" data-id="element-116">
                  <td className="p-4 font-bold text-gray-800 bg-gray-50 text-base" data-id="element-117">
                    {row.cat}
                  </td>
                  <td className="p-4 text-gray-700 text-center border-r border-gray-100 font-medium text-base" data-id="element-118">
                    {row.sin}
                  </td>
                  <td className="p-4 text-dark font-bold text-center bg-green-50/30 text-base" data-id="element-119">
                    {row.con}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        {/* Mobile Cards */}
        <div className="md:hidden space-y-4" data-id="element-120">
          {comparison.map((row, i) => <div key={i} className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-121">
              <div className="bg-gray-100 p-3 font-bold text-gray-800 text-sm border-b border-gray-200" data-id="element-122">
                {row.cat}
              </div>
              <div className="p-3 border-b border-gray-100" data-id="element-123">
                <div className="flex items-center text-red-700 font-bold text-xs mb-1.5" data-id="element-124">
                  <X className="w-3.5 h-3.5 mr-1" data-id="element-125" /> SIN MEGAPACK
                </div>
                <div className="text-gray-700 text-sm font-medium pl-4.5" data-id="element-126">
                  {row.sin}
                </div>
              </div>
              <div className="p-3 bg-green-50/30" data-id="element-127">
                <div className="flex items-center text-primary font-bold text-xs mb-1.5" data-id="element-128">
                  <Check className="w-3.5 h-3.5 mr-1" data-id="element-129" /> CON MEGAPACK
                </div>
                <div className="text-dark text-sm font-bold pl-4.5" data-id="element-130">
                  {row.con}
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </Section>;
}